import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import { ApplicationState } from '@/state/root.models'

import { RestApiService } from '@/services'
import { setLoadingFullAction } from '@/state/ui/global/slices/index.slices'
import { setSelectBrandAction } from '@/state/auth/slices/index.slices'

import { USER } from '@/state/user/thunks/api.routes'
import { Brands } from '@/state/user/models'
import ActionTypes from '../constants'

import { GetUserResponse, AuthState, UserLogged } from '../models'

const restApiService: RestApiService = Container.get(RestApiService)

export const getLoggedInUserThunk = createAsyncThunk(
  ActionTypes.LOGGED_IN_USER,
  async (_, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState() as ApplicationState

      restApiService.requestParams = {
        method: 'GET',
        endpoint: `${USER.FIND_USER}?id=${auth.userSession.id}`,
      }

      const response: GetUserResponse = await restApiService.sendAuthData(
        auth.token,
      )

      if (response !== undefined) {
        const user: UserLogged = { ...response }
        const listBrands = user.brands.filter(
          (brand: Brands) => brand.name === auth.brand.name,
        )
        if (auth.brand.name !== '' && listBrands.length > 0) {
          thunkAPI.dispatch(setSelectBrandAction(listBrands[0]))
        } else {
          thunkAPI.dispatch(setSelectBrandAction(user.brands[0]))
        }
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getLoggedInUserExtraReducer = (
  builder: ActionReducerMapBuilder<AuthState>,
) => {
  builder.addCase(getLoggedInUserThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getLoggedInUserThunk.fulfilled, (state, { payload }) => {
    sessionStorage.setItem('user', JSON.stringify(payload))
    state.loggedUser = payload || state.loggedUser
  })
}

export default getLoggedInUserExtraReducer
